import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c8c7b7f2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c7b7f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8c7b7f2')) {
      api.createRecord('c8c7b7f2', component.options)
    } else {
      api.reload('c8c7b7f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c8c7b7f2&scoped=true&", function () {
      api.rerender('c8c7b7f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/customers/custToFollowUser/index.vue"
export default component.exports